import React from 'react';
import { Box, Chip, IconButton, Tooltip, Typography } from '@mui/material';
import { Icon } from '@iconify/react';
import type { AuditDynamicFormTopBarProps } from '../../types/auditFormTypes';

const AuditDynamicFormTopBar: React.FC<AuditDynamicFormTopBarProps> = React.memo(({
  storeName,
  initialValues,
  onSwitchToJson,
  showConfidenceChip = true,
  showJsonToggle = true,
}) => {
  const confidenceLabel = initialValues?.parsed_data?.final_json?.confidence
    ? initialValues?.parsed_data?.final_json?.confidence + '%'
    : initialValues?.confidence_score + '%';

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        mb: 2,
      }}
    >
      <Typography variant="h6" fontWeight={600} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        {storeName}
      </Typography>

      <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', alignItems: 'center' }}>
        {showConfidenceChip && initialValues && (
          <Chip
            label={confidenceLabel}
            color="primary"
            size="small"
            variant="filled"
            sx={{
              bgcolor: 'black',
              color: 'white',
              borderRadius: 4,
              p: 2,
              fontSize: 16,
              fontWeight: 600,
            }}
          />
        )}

        {showJsonToggle && (
          <Tooltip title="Table View">
            <IconButton color="primary" sx={{ backgroundColor: 'rgba(44, 108, 160, 0.1)', p: 0 }}>
              <Icon icon="fluent:form-new-28-regular" fontSize={32} />
            </IconButton>
          </Tooltip>
        )}

        {showJsonToggle && (
          <Tooltip title="JSON View">
            <IconButton color="default" sx={{ backgroundColor: 'transparent', p: 0 }} onClick={onSwitchToJson}>
              <Icon icon="mdi:code-json" fontSize={32} />
            </IconButton>
          </Tooltip>
        )}
      </Box>
    </Box>
  );
});

AuditDynamicFormTopBar.displayName = 'AuditDynamicFormTopBar';

export default AuditDynamicFormTopBar;
